import { injectable } from 'inversify';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { Camera } from '../../canvas/Camera';
import { place } from '../../canvas/commands/OrderCommands';
import { Physicals } from '../../canvas/entities/Physicals';
import { TextField } from '../../canvas/fields/TextField';
import { ContentPayload } from '../../canvas/injection/ContentPayload';
import { ContentProcessor } from '../../canvas/injection/ContentProcessor';
import { TextRuler } from '../../canvas/visualization/TextRuler';
import { resolve, Resolver } from '../../Container';
import { Button } from './Button';

@injectable()
export class LinkProcessor implements ContentProcessor {

    public readonly supportedTypes = Object.freeze([
        'text/plain',
    ]);

    @resolve(Camera) private camera!: Camera;
    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(ObjectManager) private objects!: ObjectManager;
    @resolve(Resolver) private resolver!: Resolver;

    public async process(payload: ContentPayload): Promise<boolean | ContentPayload> {
        const { metadata } = payload;

        const textData = await payload.getDataAsText();
        if (!textData) return false;

        const match = textData.match(/\[(.*?)\]\((http[s]?:\/\/.*?)\)/);
        if (!match) return false;

        this.processMatchIntoLinkButton(match);
        return true;
    }

    private processMatchIntoLinkButton([_, label, url]: RegExpMatchArray) {
        const { dispatch, objects } = this;

        objects.update(() => {
            const button = Physicals.createAtCameraPosition(this.resolver, Button);
            button.background = '#3f51b5';
            button.content = label;
            button.commandScript = `openUrl "${url}"`;

            const settings = { ...(button.field('content') as TextField).toTextSettings(), fontSize: 16 };
            const size = TextRuler.measureSize(button.content, settings).add(10);
            button.width = Math.ceil(size.x / 10) * 10;
            button.height = Math.ceil(size.y / 10) * 10;
            dispatch(place, [button.id]);
        });

    }
}
